import { __assign } from "tslib";
import { TextField as MuiTextField, FilledInput as MuiFilledInput, styled, } from '@mui/material';
import { alpha } from "@mui/system";
export var StyledTextField = styled(MuiTextField, {
    shouldForwardProp: function (prop) { return !['isEdit'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, isEdit = _a.isEdit;
    return (__assign(__assign({}, (isEdit && {
        '.MuiInputBase-root': {
            '&:after': {
                borderColor: theme.palette.primary.main,
                transform: "scaleX(1)",
            },
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
        },
        '.MuiFilledInput-root': {
            outline: "1px solid ".concat(theme.palette.primary.main),
        },
    })), { '.Mui-disabled, .Mui-readOnly': {
            pointerEvents: "none"
        }, 'input': {
            '&[readonly]': {
                backgroundColor: alpha(theme.palette.greySecondary[50], 0.2)
            },
            '&[type=number]': {
                'MozAppearance': 'textfield',
            },
            '&::-webkit-outer-spin-button': {
                'WebkitAppearance': 'none',
                margin: 0,
            },
            '&::-webkit-inner-spin-button': {
                'WebkitAppearance': 'none',
                margin: 0,
            },
        } }));
});
export var StyledFilledInput = styled(MuiFilledInput)({});
//# sourceMappingURL=styled.js.map